// extracted by mini-css-extract-plugin
export var completionBody = "_cc-2";
export var completionCard = "_cc-0";
export var completionFooter = "_cc-3";
export var completionTitle = "_cc-1";